import { throttle } from '../utils';

/**
 * View script for Doctor Experience block
 */

class DoctorExperienceController {
	constructor(element) {
		this.block = element;
		this.stickyImage = this.block.querySelector(
			'.doctor-image .wp-block-improntad-blocks-responsive-image'
		);

		if (this.stickyImage) {
			this.init();
		}
	}

	init() {
		this.bindEvents();
		this.updateHeight();
	}

	bindEvents() {
		const throttledUpdate = throttle(this.updateHeight.bind(this), 150);
		this.observer = new ResizeObserver(throttledUpdate);
		this.observer.observe(this.stickyImage);
	}

	updateHeight() {
		const height = this.stickyImage.offsetHeight;
		this.block.style.setProperty('--sticky-image-height', `${height}px`);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const blocks = document.querySelectorAll(
		'.wp-block-improntad-theme-blocks-doctor-experience'
	);
	blocks.forEach((block) => new DoctorExperienceController(block));
});
